import React from "react";
import { Link } from "react-router-dom";

/**
 * TrawellB2B word-mark using the uploaded artwork.
 * `variant`: "dark" (default, dark chip) or "light" (transparent, for use on light backgrounds).
 * `size`:    "sm" | "md" | "lg" | "xl" — controls image height.
 */
export default function Logo({
  size = "md",
  to = "/",
  className = "",
  showTagline = false,
  variant = "dark",
}) {
  const heights = { sm: "h-9", md: "h-14", lg: "h-24", xl: "h-32 md:h-40" };
  const paddings = { sm: "px-3 py-1.5", md: "px-4 py-2", lg: "px-6 py-3", xl: "px-8 py-4" };
  const h = heights[size] || heights.md;
  const pad = paddings[size] || paddings.md;

  const chipCls =
    variant === "light"
      ? "bg-transparent"
      : `bg-[#0B0B0B] rounded-md ${pad} shadow-[0_1px_0_rgba(255,255,255,0.05)_inset] ring-1 ring-white/5`;

  const img = (
    <img
      src="/trawell-b2b-logo.webp"
      alt="Trawell D B2B — Curating Amazing"
      className={`${h} w-auto object-contain select-none`}
      draggable={false}
    />
  );

  return (
    <Link
      to={to}
      className={`inline-flex flex-col leading-none ${className}`}
      data-testid="logo-link"
    >
      <span className={`inline-flex items-center ${chipCls}`}>{img}</span>
      {showTagline && (
        <span className="font-mono text-[10px] uppercase tracking-[0.28em] text-muted mt-2">
          by Trawell DMC · Curating Amazing
        </span>
      )}
    </Link>
  );
}
